module.exports = __webpack_public_path__ + "img/Rectangle 25.00f0f66c.png";